import React from "react";
import { Link } from "react-router-dom";
import FooterOne from "../Footer/FooterOne";
import Header from "../Header/HeaderTwo";
import { pageTitle } from "../PageTitle";

const ServicesDetails = () => {
  pageTitle("Services Details");
  return (
    <>
      <Header></Header>
      <div className="services__details section-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-8">
              <div className="services__details-left">
                <div
                  className="services__details-left-content mb-40"
                  style={{ paddingTop: "13%" }}
                >
                  {/* <h2 className="mb-30">Terms & Conditions</h2> */}
                  <div className="contact__area-title">
                    <span className="subtitle">Terms & Conditions</span>
                  </div>
                  <ol type="1">
                    <li>Acceptance of Terms</li>
                    <p>
                      By accessing or using the App, you agree to be bound by
                      these Terms, which constitute a legally binding agreement
                      between you and EL BROKER Real Estate Brokerage ("EL
                      BROKER Brokerage"). These Terms apply to all users of the
                      App, including without limitation users who are agents,
                      buyers, sellers, or browsers.
                    </p>
                    <li>Use of the App</li>
                    <p>
                      You agree to use the App solely for its intended purposes.
                      You may not use the App for any unlawful or prohibited
                      purpose. You further agree not to: Violate any applicable
                      laws or regulations; Interfere with or disrupt the
                      operation of the App; Attempt to gain unauthorized access
                      to any portion of the App; Use the App in any manner that
                      could damage, disable, overburden, or impair the App or
                      interfere with any other party's use of the App; Engage in
                      any conduct that restricts or inhibits any other user from
                      using or enjoying the App.
                    </p>
                    <li>Registration and Accounts</li>
                    <p>
                      In order to access certain features of the App, you may be
                      required to register for an account. When registering for
                      an account, you agree to provide accurate and complete
                      information. You are responsible for maintaining the
                      confidentiality of your account credentials and for all
                      activities that occur under your account.
                    </p>
                    <li>Intellectual Property</li>
                    <p>
                      All content included on the App, including text, graphics,
                      logos, images, audio clips, and software, is the property
                      of EL BROKER Brokerage or its licensors and is protected
                      by intellectual property laws. You may not use, reproduce,
                      distribute, or display any portion of the App without the
                      prior written consent of EL BROKER Brokerage.
                    </p>
                    <li>Third-Party Links</li>
                    <p>
                      The App may contain links to third-party websites or
                      services that are not owned or controlled by EL BROKER
                      Brokerage. EL BROKER Brokerage has no control over, and
                      assumes no responsibility for, the content, privacy
                      policies, or practices of any third-party websites or
                      services. By using the App, you expressly release EL
                      BROKER Brokerage from any and all liability arising from
                      your use of any third-party website or service.
                    </p>
                    <li>Disclaimer of Warranties</li>
                    <p>
                      The App is provided on an "as is" and "as available"
                      basis, without any warranties of any kind, either express
                      or implied. EL BROKER Brokerage disclaims all warranties,
                      including but not limited to warranties of
                      merchantability, fitness for a particular purpose, and
                      non-infringement.
                    </p>
                    <li>Limitation of Liability</li>
                    <p>
                      To the fullest extent permitted by law, EL BROKER
                      Brokerage shall not be liable for any indirect,
                      incidental, special, consequential, or punitive damages,
                      or any loss of profits or revenues, whether incurred
                      directly or indirectly, or any loss of data, use,
                      goodwill, or other intangible losses, resulting from your
                      access to or use of or inability to access or use the App;
                      any conduct or content of any third party on the App; or
                      unauthorized access, use, or alteration of your
                      transmissions or content.
                    </p>
                    <li>Indemnification</li>
                    <p>
                      You agree to indemnify and hold EL BROKER Brokerage
                      harmless from any and all claims, liabilities, damages,
                      costs, and expenses, including reasonable attorneys' fees,
                      arising out of or in any way connected with your use of
                      the App or your violation of these Terms.
                    </p>
                    <li>Changes to Terms</li>
                    <p>
                      EL BROKER Brokerage reserves the right to modify or revise
                      these Terms at any time, and such changes will be
                      effective immediately upon posting to the App. Your
                      continued use of the App following the posting of any
                      changes to these Terms constitutes acceptance of those
                      changes.
                    </p>
                    <li>Governing Law</li>
                    <p>
                      These Terms shall be governed by and construed in
                      accordance with the laws of, without regard to its
                      conflict of law principles.
                    </p>
                    <li>Contact Us</li>
                    <p>
                      If you have any questions about these Terms, please
                      contact us at [elbrokerapp@gmail.com].
                    </p>
                  </ol>
                  {/* <p>
                    Research for your next design project is done by a team of
                    industry experts. We help with research, data analysis, and
                    visualization. Our expertise covers many different fields
                    including UX Design, Brand Strategy, Content Writing, User
                    Experience Design and more.
                  </p> */}
                </div>
                {/* <div className="services__details-left-image mb-60">
                  <img src="assets/img/services_details-1.jpg" alt="" />
                  <div className="row mt-30">
                    <div className="col-sm-6 sm-mb-30">
                      <img
                        className="img__full"
                        src="assets/img/services_details-2.jpg"
                        alt=""
                      />
                    </div>
                    <div className="col-sm-6">
                      <img
                        className="img__full"
                        src="assets/img/services_details-3.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div> */}
                {/* <div className="services__details-left-feedback">
                  <div className="row">
                    <div className="col-xl-6 xl-mb-30">
                      <div className="feedback__area-item">
                        <div className="feedback__area-item-quote">
                          <img src="assets/img/icon/quote.png" alt="" />
                        </div>
                        <div className="feedback__area-item-reviews">
                          <h5>Good :</h5>
                          <ul>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="feedback__area-item-content">
                          <p>
                            pellentesque in dolor vel malesuada. Donec finibus
                            libero odio, ac iaculis metus mattis quis.
                          </p>
                        </div>
                        <div className="feedback__area-item-bottom">
                          <div className="feedback__area-item-bottom-avatar">
                            <img
                              src="assets/img/avatar/feedback-1.jpg"
                              alt=""
                            />
                          </div>
                          <div className="feedback__area-item-bottom-title">
                            <h5>david bowie</h5>
                            <span>UX Designer</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 lg-mb-30">
                      <div className="feedback__area-item">
                        <div className="feedback__area-item-quote">
                          <img src="assets/img/icon/quote.png" alt="" />
                        </div>
                        <div className="feedback__area-item-reviews">
                          <h5>Good :</h5>
                          <ul>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="feedback__area-item-content">
                          <p>
                            pellentesque in dolor vel malesuada. Donec finibus
                            libero odio, ac iaculis metus mattis quis.
                          </p>
                        </div>
                        <div className="feedback__area-item-bottom">
                          <div className="feedback__area-item-bottom-avatar">
                            <img
                              src="assets/img/avatar/feedback-2.jpg"
                              alt=""
                            />
                          </div>
                          <div className="feedback__area-item-bottom-title">
                            <h5>michel aoun</h5>
                            <span>Marketing</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="col-xl-4 col-lg-4">
              <div className="all__sidebar ml-25 xl-ml-0">
                <div className="all__sidebar-item services">
                  <h4>Our Services</h4>
                  <div className="all__sidebar-item-category">
                    <ul>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Design
                          Research<span>(08)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>
                          Development<span>(06)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Digital
                          Marketing<span>(05)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Branding
                          <span>(09)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Market
                          Research<span>(03)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>SEO
                          marketing<span>(02)</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="all__sidebar-item-help"
                  style={{ backgroundImage: `url('assets/img/details-3.jpg')` }}
                >
                  <h4>Need Any Help?</h4>
                  <div className="all__sidebar-item-help-contact">
                    <div className="all__sidebar-item-help-contact-icon">
                      <i className="fal fa-phone-alt"></i>
                    </div>
                    <div className="all__sidebar-item-help-contact-content">
                      <span>Quick Help</span>
                      <h6>
                        <a href="tel:+123(458)896895">01552710828</a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <FooterOne></FooterOne>
    </>
  );
};

export default ServicesDetails;
